<template>
  <div class="Dashbord">
    <div class="Actions__Content">
      <v-container fluid>
        <Breadcrumbs />
        <!-- /.Breadcrumbs -->

        <section class="TankRoom">
          <h2>{{ this.wineName }}</h2>
          <div class="VineYear__Content">
            <div class="VineYear__Content__Vine">
              <div class="VineBox">
                <div class="VineBox__Img">
                  <img v-if="this.label !== undefined"
                  v-bind:id="'slika_' + this.idWineYear"
                    v-bind:src="slika"
                    @error="slika = '../assets/iconsWine/wineImg.png?sig=' + new Date()"
                    alt="Boca Vina"
                  />
                </div>
                <!-- /.VineBox__Img -->
                <!-- <div class="VineBox__Title">
                  <p v-if="this.label !== undefined">
                    {{ this.label.bottleVolumeInLiters }} l

                    <button @click="submit_izmena_slike" style="height:15px;width:15px;float: right; margin-right: 3px;">
                  <img
                    :src="`../assets/Ikone/icons8-edit-24_bela.png`"
                    alt="icon"
                    title="Izmena slike etikete"
                  />
                </button>
                  </p>
                  
                </div> -->
              </div>
              <div class="TankDetails" style="width:24px;padding:0px;">
                    <button @click="submit_izmena_slike" style="padding-top: 220px;">
                  <img
                    :src="`../assets/Ikone/icons8-edit-24_bela.png`"
                    alt="icon"
                    title="Izmena slike etikete"
                  />
                </button>
                </div>
              <!-- /.VineBox -->

              <!-- <div class="VineYears">
                <span v-for="item in items.wines" :key="item.id">
                  <router-link
                    :to="{ name: 'single_wine', params: { id: item.id } }"
                    class="columnRightVineType"
                  >
                    {{ item.year }}
                  </router-link>
                </span>
              </div> -->
              <!-- /.VineYears -->
            </div>
            <!-- /.VineYear__Content__Vine -->
            <div class="TankDetails">
              <div class="TankDetails__Item">
                <span class="label">Redosled na prikazu:</span>
                <span class="value_manji" v-if="this.label !== undefined">{{
                  this.label.position
                }}</span>
              </div>
              <div class="TankDetails__Item">
                <span class="label">Bar kod:</span>
                <span class="value_manji" v-if="this.label !== undefined">{{
                  this.label.ean
                }}</span>
              </div>
              <div class="TankDetails__Item">
                <span class="label">Zapremina boce:</span>
                <span class="value_manji" v-if="this.label !== undefined">{{
                  this.label.bottleVolumeInLiters
                }} l</span>
              </div>
              <div class="TankDetails__Item">
                <span class="label">Temperatura služenja:</span>
                <span class="value_manji" v-if="this.label !== undefined">{{
                  this.label.serviceTemperature
                }} °C</span>
              </div>
            </div>
            <div class="TankDetails">
              <div class="TankDetails__Item" style="height:50%;width:100%;">
                <span class="label" style="width:10%;vertical-align: top;">Opis:</span>
                <span class="value" style="width:95%!important;height: 80% !important;border: solid 1px #DEDEDE; padding-left:5px;padding-right:5px;" v-if="this.label !== undefined">{{
                  this.label.description
                }}</span>
              </div>
              <div class="TankDetails__Item" style="height:50%;width:100%;">
                <span class="label" style="width:10%;vertical-align: top;">Hrana:</span>
                <span class="value" style="width:95%!important;height: 80% !important;border: solid 1px #DEDEDE; padding-left:5px;padding-right:5px;" v-if="this.label !== undefined">{{
                  this.label.foodPairing
                }}</span>
              </div>
            </div>
            <div>
              <span class="label">
                <button @click="submit_izmena" style="padding-top:5px;">
                  <img
                    :src="`../assets/Ikone/icons8-edit-24_bela.png`"
                    alt="icon"
                    title="Izmena podataka o etiketi"
                  />
                </button>
              </span>
            </div>
          </div>
          <!-- /.VineYear__Content -->
        </section>
        <!-- /.VineYear -->
      </v-container>
    </div>
    <!-- /.Actions__Content -->

    <v-container
      fluid
      style="padding-top: 0px;
        padding-bottom: 10px;
        padding-left: 57px;
        padding-right: 57px;
      "
    >
      <v-layout row>
        <v-flex xs12 style="overflow: auto">
          <v-data-table
            :headers="headers"
            :items="items_state_table"
            hide-actions
            class="elevation-1"
            
            style="padding: 5px"
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column',
                    '',
                    '',
                    header.align === 'left'
                      ? 'text-xs-left'
                      : header.align === 'right'
                      ? 'text-xs-right'
                      : 'text-xs-center',
                  ]"
                >
                  {{ header.text }}
                </th>
              </tr>
            </template>

            <template slot="items" slot-scope="props">
              <tr>
                <td style="text-align: center">
                  <a
                    class="columnRightVineType"
                    style="font-weight: bold"
                    v-on:click="routerLinkToDetails(props.item.wineId)" v-if="props.item.year!=='Ukupno:'"
                    >{{ props.item.year }}</a
                  >
                  <template v-else>
                    Ukupno:
                  </template>
                </td>
                <td style="text-align: right">
                  {{ currencyFormatDE(props.item.bottling) }}
                </td>
                <td style="text-align: right">
                  {{ currencyFormatDE(props.item.warehouseState) }}
                </td>
                <td style="text-align: right">
                  {{ currencyFormatDE(props.item.output) }}
                </td>
                <td style="text-align: right">
                  {{ currencyFormatDE(props.item.writeOff) }}
                </td>
                <td style="text-align: right">
                  {{ currencyFormatDE(props.item.selling) }}
                </td>
                <td style="text-align: right">
                  {{ currencyFormatDEdec(props.item.sellingValue) }}
                </td>
              </tr>
            </template>
            <template slot="no-data">
              <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
              <v-alert slot="no-results" :value="true" color="error" icon="info"
                >Nema podataka.</v-alert
              >
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
              >Nema podataka.</v-alert
            >
          </v-data-table>
        </v-flex>
      </v-layout>
      <v-layout
        row
        style="text-align: right; padding-right: 30px; padding-top: 10px"
      >
        <v-flex xs6> </v-flex>
        <v-flex xs6> *Vrednost je sa rabatom i pdv-om </v-flex>
      </v-layout>

      <v-layout style="padding-top: 14px">
        <v-flex xs12>
          <div ref="chartdiv" style="height: 400px"></div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog
      v-model="dialogNote_izmena_etikete"
      scrollable
      content-class="ModalInModalSrednji"
      persistent
    >
      <v-container style="padding: 0px">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <div
              data-v-fae5bece
              class="v-card__title headline lighten-2 v-card__title--primary"
              style="padding-left: 30px; padding-bottom: 0px"
            >
              <!-- Modal Titles  -->

              <div v-if="this.wineName !== undefined">{{ this.wineName }}</div>

              <button
                id="closeModalBtn"
                @click.prevent="closeModal"
                class="v-btn v-btn--flat white"
              >
                <v-icon>close</v-icon>
              </button>
            </div>

            <div data-v-fae5bece class="spacer"></div>
            <MyComponent
              @newdata="handleData($event)"
              @close="closeModal"
              :item="label_pom"
            ></MyComponent>
          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>
    <v-dialog
      v-model="dialogNote_izmena_slike"
      scrollable
      content-class="ModalInModalSrednji"
      persistent
    >
      <v-container style="padding: 0px">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <div
              data-v-fae5bece
              class="v-card__title headline lighten-2 v-card__title--primary"
              style="padding-left: 30px; padding-bottom: 0px"
            >
              <!-- Modal Titles  -->

              <div v-if="this.wineName !== undefined">{{ this.wineName }}</div>

              <button
                id="closeModalBtn"
                @click.prevent="closeModalSlika"
                class="v-btn v-btn--flat white"
              >
                <v-icon>close</v-icon>
              </button>
            </div>

            <div data-v-fae5bece class="spacer"></div>
            <MyImageComponent
              @newdata="handleDataSlika($event)"
              @close="closeModalSlika"
              :item="label_pom"
            ></MyImageComponent>
          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>

    <TokenComponent ref="frmtoken" />
  </div>
  <!-- /.Dashboard -->
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

import am4lang_de_DE from "@amcharts/amcharts4/lang/de_DE";

// import * as am4plugins_sunburst from "@amcharts/amcharts4/plugins/sunburst";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

import Breadcrumbs from "../components/layoutComponents/Breadcrumbs";
import TokenComponent from "../components/Token";

import MyComponent from "../components/WineLabelPomItemComponent.vue";
import MyImageComponent from "../components/WineLabelPomImageComponent.vue";


import { nadjiSliku } from "../helpers/Functions";


export default {
  name: "VineYear",
  dialog: false,
  components: {
    Breadcrumbs,
    TokenComponent,
    MyComponent,
    MyImageComponent
  },
  data() {
    return {
      pagination: {
        sortBy: "year",
        rowsPerPage: 10000000,
        descending: true,
      },
      idWineYear: 0,
      items: [],
      label_pom: undefined,
      wineName: "",
      wineTypeName: "",
      label: undefined,
      slika: '',
      headers: [
        { text: "Berba", value: "", align: "center" },
        { text: "Flaširano", value: "", align: "right" },
        { text: "Na stanju", value: "", align: "right" },
        { text: "Izdato", value: "", align: "right" },
        { text: "Otpisano", value: "", align: "right" },
        { text: "Prodato", value: "", align: "right" },
        { text: "Vrednost prodaje", value: "", align: "right" },
      ],
      items_state: [],
      items_state_table: [],
      objStateUkupno: {},

dialogNote_izmena_etikete: false,
dialogNote_izmena_slike: false
    };
  },
  methods: {
    routerLinkToDetails(lokID) {
      this.$router.push({
        name: "single_wine",
        params: { id: lokID, slika: document.getElementById("slika_" + this.idWineYear).src },
      });
    },
    ucitajGrafik: function () {
      let chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart);

      chart.data = this.items_state;

      var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "year";
      categoryAxis.title.text = "Berba";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 20;

      chart.numberFormatter.numberFormat = "#.";
      chart.numberFormatter.language.locale = am4lang_de_DE;

      // Create a separate NumberFormatter for avalue axis,
      // and make it round axis label values to two decimals

      var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.title.text = "Broj boca (kom)";

      valueAxis.numberFormatter = new am4core.NumberFormatter();
      valueAxis.numberFormatter.numberFormat = "#,###";

      // // Create series
      // var series = chart.series.push(new am4charts.ColumnSeries());
      // series.dataFields.valueY = "bottling";
      // series.dataFields.categoryX = "year";
      // series.name = "Flaširano";
      // series.tooltipText = "{name}: [bold]{valueY}[/]";
      // // This has no effect
      // // series.stacked = true;

      var series5 = chart.series.push(new am4charts.ColumnSeries());
      series5.dataFields.valueY = "warehouseState";
      series5.dataFields.categoryX = "year";
      series5.name = "Na stanju";
      series5.tooltipText = "{name}: [bold]{valueY}[/]";
      // series5.stacked = true;

      var series3 = chart.series.push(new am4charts.ColumnSeries());
      series3.dataFields.valueY = "output";
      series3.dataFields.categoryX = "year";
      series3.name = "Izdato";
      series3.tooltipText = "{name}: [bold]{valueY}[/]";
      series3.stacked = true;

      var series4 = chart.series.push(new am4charts.ColumnSeries());
      series4.dataFields.valueY = "writeOff";
      series4.dataFields.categoryX = "year";
      series4.name = "Otpisano";
      series4.tooltipText = "{name}: [bold]{valueY}[/]";
      series4.stacked = true;

      var series2 = chart.series.push(new am4charts.ColumnSeries());
      series2.dataFields.valueY = "selling";
      series2.dataFields.categoryX = "year";
      series2.name = "Prodato";
      series2.tooltipText = "{name}: [bold]{valueY}[/]";
      // Do not try to stack on top of previous series
      series2.stacked = true;

      // Add cursor
      chart.cursor = new am4charts.XYCursor();

      // Add legend
      chart.legend = new am4charts.Legend();
    },
    currencyFormatDE(num) {
      if (num !== undefined && num !== null)
        return num
          .toFixed(0) // always two decimal digits
          .replace(".", ",") // replace decimal point character with ,
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
      // use . as a separator
      else return 0;
    },
    currencyFormatDEdec(num) {
      if (num !== undefined && num !== null)
        return num
          .toFixed(2) // always two decimal digits
          .replace(".", ",") // replace decimal point character with ,
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
      // use . as a separator
      else return 0;
    },
    submit_izmena(e) {
      e.preventDefault();
      this.dialogNote_izmena_etikete = true;

      this.label_pom = this.label;
    },
    handleData: function (e) {
      this.getDataLabel();
      this.dialogNote_izmena_etikete = false;
      this.label_pom = undefined;
    },
    closeModal() {
      this.dialogNote_izmena_etikete = false;
      this.label_pom = undefined;
    },
    submit_izmena_slike(e) {
      e.preventDefault();
      this.dialogNote_izmena_slike = true;

      this.label_pom = this.label;
    },
    handleDataSlika: function (e) {
      // this.getDataLabel();
      this.slika = "";

      this.slika = nadjiSliku(this.idWineYear);

      this.dialogNote_izmena_slike = false;
      this.label_pom = undefined;
    },
    closeModalSlika() {
      this.slika = "";

      this.slika = nadjiSliku(this.idWineYear);

      this.dialogNote_izmena_slike = false;
      this.label_pom = undefined;
    },
    changeSort(column) {
      if (column !== "funkcije")
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending;
        } else {
          this.pagination.sortBy = column;
          this.pagination.descending = false;
        }

      // this.items_state_table.push(this.objStateUkupno)
    },
    getAllSifarnik() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/wine/wine_label/" +
            this.idWineYear,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.items = response.data;
          this.wineName = response.data.wineLabel.name;
          this.wineTypeName = response.data.wineLabel.wineType.name;
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/wine/wine_label/" +
                        this.idWineYear,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.items = response.data;
                      this.wineName = response.data.wineLabel.name;
                      this.wineTypeName = response.data.wineLabel.wineType.name;
                    })
                    .catch((e) => {
                      // // console.log(e.message);
                      alert(1);
                      // alert(this.$lang.general.greskaNaServeru);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getDataLabel() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/wine_label/" +
            this.idWineYear,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.label = response.data;
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/wine_label/" +
                        this.idWineYear,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.label = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.message);
                      alert(1);
                      // alert(this.$lang.general.greskaNaServeru);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getDataTable() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/wine_label/overview/" +
            this.idWineYear,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.items_state = response.data;
          this.items_state_table = [];
          let _this = this;


          let flasirano = 0;
          let prodato = 0;
          let izdato = 0;
          let otpisano = 0;
          let ostalo = 0;
          let vrednost_prodaje = 0;

          response.data.forEach(function (entry) {
            flasirano = flasirano + entry.bottling;
            prodato = prodato + entry.selling;
            izdato = izdato + entry.output;
            otpisano = otpisano + entry.writeOff;
            ostalo = ostalo + entry.warehouseState;
            vrednost_prodaje = vrednost_prodaje + entry.sellingValue;

            _this.items_state_table.push(entry);
          });

          this.objStateUkupno = {
            year: "Ukupno:",
            bottling: flasirano,
            selling: prodato,
            output: izdato,
            writeOff: otpisano,
            warehouseState: ostalo,
            sellingValue: vrednost_prodaje,
          };

          this.items_state_table.push(this.objStateUkupno);

          this.ucitajGrafik();
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/wine_label/overview/" +
                        this.idWineYear,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.items_state = response.data;
          this.items_state_table = [];
          let _this = this;


          let flasirano = 0;
          let prodato = 0;
          let izdato = 0;
          let otpisano = 0;
          let ostalo = 0;
          let vrednost_prodaje = 0;

          response.data.forEach(function (entry) {
            flasirano = flasirano + entry.bottling;
            prodato = prodato + entry.selling;
            izdato = izdato + entry.output;
            otpisano = otpisano + entry.writeOff;
            ostalo = ostalo + entry.warehouseState;
            vrednost_prodaje = vrednost_prodaje + entry.sellingValue;

            _this.items_state_table.push(entry);
          });

          this.objStateUkupno = {
            year: "Ukupno:",
            bottling: flasirano,
            selling: prodato,
            output: izdato,
            writeOff: otpisano,
            warehouseState: ostalo,
            sellingValue: vrednost_prodaje,
          };

          this.items_state_table.push(this.objStateUkupno);

          this.ucitajGrafik();
                    })
                    .catch((e) => {
                      // // console.log(e.message);
                      alert(1);
                      // alert(this.$lang.general.greskaNaServeru);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
  },
  watch: {
    $route() {
      this.idWineYear = this.$route.params.id;
      this.slika = nadjiSliku(this.idWineYear);
      // this.getAllSifarnik();
    },
  },
  mounted() {
    // alert('makari');

    this.idWineYear = this.$route.params.id;
    this.slika = nadjiSliku(this.idWineYear);

    this.getAllSifarnik();
    this.getDataLabel();
    this.getDataTable();
  },
};
</script>

<style scoped lang='scss'>
@import "./../assets/sass/parts/modalStyles";
@import "../assets/sass/parts/_tanksRoom.scss";
.more_info {
  color: #000;
  font-size: 14px;
  padding: 6px 14px 3px;
  margin: auto 0 auto auto;
  border-radius: 3px;
  text-align: center;
  border: solid 1px #000;
  text-decoration: none;
  // text-transform: uppercase;
  font-family: NunitoSans, sans-serif;
}

.VineBox {
  position: relative;
  width: 163px;
  height: 243px;
  border: 1px solid #e2e2e2;
  margin: 0px 10px 0px;
  transition: border 0.2s ease-in-out;

  &__Img {
    height: 100%;
    img {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
  }
  &__Title {
    font-size: 12px;
    font-weight: bold;
    line-height: 1;
    letter-spacing: 0;
    text-align: center;
    color: #333333;
    margin-top: 10px;
    padding-left: 7px;
    font-family: NunitoSans, sans-serif;
  }
}

.VineYear {
  margin-top: 20px;
  margin-bottom: 80px;
  &__Header {
    display: flex;
    padding: 4px 15px 0;
    justify-content: space-between;
    h2 {
      font-family: NunitoSans, sans-serif;
      font-size: 32px;
      letter-spacing: 0;
      font-weight: 300;
      // text-transform: uppercase;
      color: #000;
    }
    .more_info {
      color: #fff;
      border: solid 1px;
      margin-top: 6px;
    }
    &--crveno {
      background-color: #8e302f;
      h2 {
        color: #ffffff;
      }
      .more_info {
        color: #ffffff;
        border-color: #fff;
      }
    }
    &--belo {
      background-color: #fcf5e2;

      h2 {
        color: #d30031;
      }
      .more_info {
        border-color: #d30031;
      }
    }
    &--penusavo {
      background-color: #d8d5cb;

      h2 {
        color: #d30031;
      }
      .more_info {
        border-color: #d30031;
      }
    }
    &--rose {
      background-color: #ffcbc4;

      h2 {
        color: #d30031;
      }
      .more_info {
        border-color: #d30031;
      }
    }
    &--pojacano {
      background-color: #892b23;

      h2 {
        color: #ffffff;
      }
      .more_info {
        color: #ffffff;
        border-color: #fff;
      }
    }
    &--slatko {
      background-color: #fcc862;

      h2 {
        color: #d30031;
      }
      .more_info {
        border-color: #d30031;
      }
    }
  }

  &__Content {
    display: flex;
    flex-wrap: wrap;
    margin-top: 30px;
    &__Vine {
      display: flex;
      .VineBox {
        margin-right: 15px;
      }
      .VineYears {
        max-width: 120px;
        height: 100%;
        max-height: 310px;
        margin: -3px -3px -3px -3px;
        display: inline-flex;
        flex-wrap: wrap;
        flex-direction: column;
        justify-content: flex-start;
        span {
          display: block;
          width: 63px;
          height: 33px;
          padding-top: 2px;
          margin: 3px;
          // border-radius: 6px;
          // border: solid 1px #9b9b9b;
          font-family: NunitoSans, sans-serif;
          font-size: 18px;
          font-weight: bold;
          letter-spacing: 0;
          text-align: center;
          color: #000000;
        }
      }
    }
  }
}

.TankDetails {
  display: flex;
  padding: 0px;
  flex-direction: column;
  // border-left: 1px solid #979797;
  width: 33%;
  @include bp(_1200) {
    padding: 0 10px;
  }
  &__Item {
    > * {
      display: inline-block;
      vertical-align: middle;
    }
    margin-bottom: 4px;
    font-family: "NunitoSans", sans-serif;
    font-size: 16px;
    .label {
      width: 160px;
      letter-spacing: 0;
      color: #9b9b9b;
      margin-right: 10px;
      text-align: right;
      @include bp(_1200) {
        width: auto;
      }
    }
    .value {
      color: #000;
      width: 50%;
    }
    .value_manji {
      color: #000;
      width: 120px;
    }
    .maka {
      max-width: 200px;
      letter-spacing: 0;
      color: #9b9b9b;
      margin-right: 20px;
      @include bp(_1200) {
        width: auto;
      }
    }
    .kvaka {
      max-width: 45px;
      letter-spacing: 0;
      color: #9b9b9b;
      margin-right: 20px;
      @include bp(_1200) {
        width: auto;
      }
    }
  }
}

.Actions__Content {
  padding: 20px 33px 0px;
}

.columnRightVineType {
  color: #018389;
  text-decoration: none;
}

.table.v-datatable.v-table {
  width: 50%;
}
</style>
